import { Divider } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
import ContentBox from '../../../molecules/ContentBox';
import { formatCurrency } from '../../../../utils/functions';
import LoadingComponent from '../../../molecules/LoadingComponent';
import Permission from '../../../molecules/Permission';
import { PermissionCustomer } from '../../../../permissions/PermissionCustomer';
import NotPermissionComponent from '../../../atoms/NotPermissionComponent';
import { formatCep, formatPhone } from '../../../../utils/TextFormatters';
import { formatDateAndTime } from '../../../../utils/dateFunctions';

interface DescriptionItemProps {
    title: string;
    content: string;
    className?: string;
}

const DescriptionItem = ({ title, content, className }: DescriptionItemProps) => (
    <div title={content} className={`${className} flex gap-2 pb-2`}>
        <p className="text-sm inline-block text-gray-500 font-normal">{title}:</p>
        <p className="text-sm text-zinc-700 font-medium">{content}</p>
    </div>
);

interface ClientDetailsInformationProps {
    customer?: any;
    loading: boolean;
}

const ClientDetailsInformation: React.FC<ClientDetailsInformationProps> = observer(({ customer, loading }) => {

    return (
        <Permission permissionKeys={[PermissionCustomer.GET]} fallback={NotPermissionComponent()}>
            <ContentBox title="Informações do Cliente" description='Informações de Cadastro do Cliente' className="mb-4 p-6" borderCustom='rounded-b-lg'>

                {loading &&
                    <LoadingComponent />
                }

                {!loading &&
                    <div className="flex gap-4">
                        <div className="w-full">
                            <p className="pb-4 text-base text-primary-color">Dados de Contato</p>

                            <div className="grid grid-cols-2 gap-8">
                                <DescriptionItem title="Nome" content={customer?.firstName} />
                                <DescriptionItem title="CNPJ" content={customer?.document} />
                            </div>

                            <div className="grid grid-cols-2 gap-8">
                                <DescriptionItem title="Razão Social" content={customer?.corporateName} />
                                <DescriptionItem title="Inscrição Estadual" content={customer?.stateRegistration} />
                            </div>

                            <div className="grid grid-cols-2 gap-8">
                                <DescriptionItem title="Email" content={customer?.user?.email} />
                                <DescriptionItem title="Email Nota" content={customer?.emailNf} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Celular" content={formatPhone(customer?.mobile)} />
                                <DescriptionItem title="Telefone Fixo" content={formatPhone(customer?.phone)} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Número com Whatsapp?" content={customer?.mobileWhatsapp ? "Sim" : "Não"} />
                                <DescriptionItem title="Código da Matrícula" content={customer?.seller} />
                            </div>

                            <Divider />

                            {/* <p className="pb-3 text-base text-primary-color">Endereço de Cobrança</p>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Endereço" content={customer?.billingAddress?.street} />
                                <DescriptionItem title="Bairro" content={customer?.billingAddress?.block} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Cidade" content={customer?.billingAddress?.city} />
                                <DescriptionItem title="Estado" content={customer?.billingAddress?.state} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Pais" content={customer?.billingAddress?.country} />
                                <DescriptionItem title="CEP" content={formatCep(customer?.billingAddress?.zipCode)} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Complemento" content={customer?.billingAddress?.addressComplement} />
                                <DescriptionItem title="Numero" content={customer?.billingAddress?.number} />
                            </div>

                            <Divider /> */}

                            <p className="pb-3 text-base text-primary-color">Endereço de Entrega</p>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Endereço" content={customer?.mainAddress?.street} />
                                <DescriptionItem title="Bairro" content={customer?.mainAddress?.block} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Cidade" content={customer?.mainAddress?.city} />
                                <DescriptionItem title="Estado" content={customer?.mainAddress?.state} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Pais" content={customer?.mainAddress?.country} />
                                <DescriptionItem title="CEP" content={formatCep(customer?.mainAddress?.zipCode)} />
                            </div>

                            <div className="grid grid-cols-2 gap-8" >
                                <DescriptionItem title="Complemento" content={customer?.mainAddress?.addressComplement} />
                                <DescriptionItem title="Numero" content={customer?.mainAddress?.number} />
                            </div>
                        </div>
                    </div>
                }

            </ContentBox>
        </Permission>
    );
});

export default ClientDetailsInformation;